import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function SecureYourStay() {
  return <section data-section-id="148797" id="access-the-basecamp" className="dark bg-background text-foreground m-4 md:m-8 lg:m-12 border border-primary/20 rounded-sm relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_70%)] opacity-10 pointer-events-none"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 py-24 md:py-32 flex flex-col items-center text-center">
        <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight mb-10 text-foreground leading-tight">
          Ready to ascend?
        </h2>
        
        <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-8">
          <Button asChild size="lg" className="h-14 px-10 text-base tracking-wider uppercase font-medium bg-primary text-primary-foreground hover:bg-primary/90 transition-colors duration-300">
            <Link to="https://brandbasecamp.io">
              Access Basecamp
            </Link>
          </Button>
          
          <Button asChild variant="link" className="text-foreground/70 hover:text-primary text-base tracking-wider uppercase font-medium h-14 px-4 transition-colors duration-300">
            <Link to="#">
              Explore Services
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}